import { ListSortDirection, Sort } from "../../models/api/sort";
import { LegislationDTO, LegislationSTO } from "../../models/legislations";
import { BaseApiService } from "../base/base-api.service";

export class LegislationsApiService extends BaseApiService<LegislationDTO, LegislationSTO> {
  constructor() {
    super({
      servicePath: "/Legislations",
      loadItemsPath: "/GetLegislations",
      saveItemsPath: "/SaveLegislations",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
